<template>
    <div>
    <div style="margin-top: 10px;" v-for="comment in commentArray" :key="comment.commentText">
            <div style="display: flex; flex-direction: row; justify-content: space-between">
                <div>
                    Commented by: <span class="has-text-weight-medium">{{ comment.commented_by }}</span>
                </div>
                <div>
                    <span>{{ comment.commented_at }}</span>
                </div>
            </div>
        <div>
            <b-input style="margin-top: 10px;" type="text" v-model="comment.comment" readonly/>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "CommentField",

    props: {
        commentArray : Array
    }
}
</script>

<style scoped>

*{
    color: gray;
}

</style>